import React, { Component } from 'react';
import { NavLink } from 'reactstrap';

export default class GoogleOptionSelector extends Component {
  constructor(props) {
    super(props);
  }

  renderContent() {
    const { onSelectOption } = this.props;

    return (
      <div className='d-flex justify-content-center capture-url-google-option-selector'>
        <div>
          <div className='additional-akaire-title-block d-flex justify-content-center'>
            校正するデータを選択してください。
          </div>
          <div className="pl-3 google-option-box mt-2">
            <div className='d-flex capture-url-google-option-row'>
              <NavLink href="#" className='create-akaire-box-link cursor-pointer text-black' onClick={(event) => onSelectOption(event, 'google-video')}>
                <i className="fas fa-circle mr-2"></i> <b>動画データ</b>
              </NavLink>
              <span className='text-google-format mt-auto text-black'>（対応形式： MP4・MOV・WMV・AVI）</span>
            </div>
            <div className='d-flex capture-url-google-option-row'>
              <NavLink href="#" className='create-akaire-box-link cursor-pointer text-black' onClick={(event) => onSelectOption(event, 'google-image')}>
                <i className="fas fa-circle mr-2"></i> <b>PDFまたは画像データ</b>
              </NavLink>
              <span className='text-google-format mt-auto text-black'>（対応形式： PDF・PNG・JPG）</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.renderContent();
  }
}
